import { z } from 'zod';
import { FOB_POINT_CONSTRAINTS } from './constraints.js';
export const fobPointFormSchema = z.object({
    name: z
        .string()
        .trim()
        .min(1, `${FOB_POINT_CONSTRAINTS.name.label} is required.`)
        .max(FOB_POINT_CONSTRAINTS.name.maxLength),
});
//# sourceMappingURL=create-form.js.map